module.exports = __webpack_public_path__ + "img/2.21011b4e.jpg";